import React, { FC } from "react"
import styled from "styled-components"
import image from "../../../static/images/lp-lk-img-2.png"

interface IList {
  title: string
  text: string
}

const list: IList[] = [
  {
    title: "Вся информация о вашей КПП",
    text:
      "Договоры, финансовая и аналитическая информация, статистика, новые корпоративные программы, поддержка – все, чтобы ваша КПП была успешной.",
  },
  {
    title: "Несколько юридических лиц?",
    text: "Не проблема, переключайтесь между ними в два клика!",
  },
  {
    title: "Участники",
    text:
      "Все участники по договору, поиск участников, просмотр информации и всех операций по участнику.",
  },
]

const BlockStyle = styled.div`
  display: flex;
  max-width: 1220px;
  margin: 0 auto;
  margin-bottom: 62px;
  padding: 17px 20px;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    padding: 0 69px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0 20px;
  }

  div:first-child {
    flex: 1;
  }

  div:last-child {
    flex: 1.5;

    @media screen and (max-width: 1023px) {
      width: calc(100% + 59px);
    }

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }

  ul {
    margin-top: 32px;
    padding-left: 21px;
    padding-right: 5px;

    li {
      position: relative;
      &:before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        top: 8px;
        left: -21px;
        background: #21a038;
        display: block;
        position: absolute;
      }
    }

    h4 {
      margin-top: 21px;
      margin-bottom: 3px;
    }

    p {
      font-family: "SB Sans Interface";
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    }
  }
`

const Features: FC = () => {
  return (
    <BlockStyle>
      <div>
        <h2>Возможности личного кабинета</h2>
        <ul>
          {list.map((item, index) => (
            <li key={index}>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <img src={image} alt="screenshot-1" />
      </div>
    </BlockStyle>
  )
}

export default Features
